export default class Quantity {
  constructor(el) {
    this.$el = $(el);
    this.$inputParent = this.$el.find('.form-field--qty-input');
    this.$input = this.$el.find('[data-quantity-input]');
    this.$selectParent = this.$el.find('.form-field--qty-select');
    this.$select = this.$el.find('[data-quantity-select]');

    this.stockLimit = this.$el.data('stock-limit') || false;

    this._watchSelect = this._watchSelect.bind(this);
    this._watchInput = this._watchInput.bind(this);

    this.$select.on('change.quantity', this._watchSelect);
    this.$input.on('change.quantity', this._watchInput);
  }

  unload() {
    this.$el.off('.quantity');
  }

  _validateValue(event) {
    const baseValue = parseInt(event.currentTarget.value, 10);
    const newValue = isNaN(baseValue) ? 1 : baseValue;

    let isValid = true;
    let value = newValue;

    // Check if there is a stock limit on the product
    if (this.stockLimit) {
      const limit = parseInt(this.stockLimit, 10);
      isValid = newValue <= limit;

      value = Math.min(limit, newValue);

      if (!isValid) {
        this.$el.trigger('quantity:error', { limit });
      }
    }

    return { isValid, value };
  }

  _watchSelect(event) {
    const { value, isValid } = this._validateValue(event);

    // Update select with sanitized value
    if (!isValid) {
      return this.$select.val(value);
    }

    // Update input to match select
    this.$input.val(value).trigger('change');

    // Switch to quantity input when 10 or more
    if (value >= 10) {
      this.$inputParent
        .removeClass('hidden')
        .addClass('visible');

      this.$input
        .focus()
        .removeAttr('tabindex')
        .select();

      this.$selectParent
        .removeClass('visible')
        .addClass('hidden');

      this.$select.attr('tabindex', '-1');
    }
  }

  _watchInput(event) {
    const { value } = this._validateValue(event);

    this.$input.val(value);
  }
}
